import React, { useState, useEffect } from "react";
import { Navigate } from 'react-router-dom';
import { userService } from "../../_services";
import { Loader2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import Add_sec from "./add_sec";
import Affiliate_id_total from "./affiliate_id_total";
import Affiliate_refferal_url from "./AffiliateReferralUrl.jsx";
import Pricing_tool from "./Pricing_tool";
import Refferals_list from './refferals_list';
import Active_inactive_refs from './ActiveInactiveRefs.jsx';

/**
 * Affiliate URL Page
 * Matches dev-v3 layout structure exactly
 */
function Affiliate_Url() {
    const [userData, setUserData] = useState([]);
    const [referralList, setReferralList] = useState([]);
    const [shortname, setShortname] = useState('');
    const [fullName, setFullName] = useState('');
    const [accountInfo, setAccountInfo] = useState('');
    const [isDocuSigned, setIsDocuSigned] = useState(false);
    const [adminApproval, setAdminApproval] = useState(false);
    const [referralLink_RequestStatus, setReferralLink_RequestStatus] = useState(false);
    const [referralLink_AdminApproval, setReferralLink_AdminApproval] = useState("");
    const [powerformLink, setPowerformLink] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const userId = Usermeta_Data.split(':')[0];
            const userName = Usermeta_Data.split(':')[1];
            
            getUserDashboardDetails(userId, userName);
            
            const usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
            setShortname(usernamedata.split(':')[0]);
            setFullName(usernamedata.split(':')[1]);
            
            const userinfo = window.atob(localStorage.getItem('_file_info'));
            setAccountInfo(userinfo);
            
            // Check for DocuSign completion
            if (window.location.href.includes('/ref?sign_completed') || window.location.href.includes('/affiliate?sign_completed')) {
                submitDocuSign(true, userId, window.localStorage.getItem('AffiliateReferralURL'));
            }
        } catch (error) {
            console.error('Error initializing:', error);
            logout();
        }
    }, []);

    const updateAffiliateRequest = () => {
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            getUserDashboardDetails(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        } catch (error) {
            console.error('Error updating affiliate request:', error);
        }
    };

    const submitDocuSign = async (issigned, userid, signdetail) => {
        try {
            const apidata = await userService.submit_docusign(issigned, userid, signdetail);
            
            if (apidata && apidata.length > 0 && apidata[0].code !== "-1") {
                localStorage.removeItem("AffiliateReferralURL");
                const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.pushState({ path: newurl }, '', newurl);
                
                const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
                getUserDashboardDetails(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
            }
        } catch (error) {
            console.error('Error submitting DocuSign:', error);
        }
    };

    const getPricing = () => {
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            getUserDashboardDetails(Usermeta_Data.split(':')[0], Usermeta_Data.split(':')[1]);
        } catch (error) {
            console.error('Error getting pricing:', error);
        }
    };

    const getUserDashboardDetails = async (userId, userName) => {
        // Clear states
        setPowerformLink('');
        setIsDocuSigned('');
        setReferralLink_AdminApproval('');
        setReferralLink_RequestStatus('');
        setUserData([]);
        setReferralList([]);
        setAdminApproval('');
        
        try {
            const apidata = await userService.GetUserDashboardDetails(userId, userName);
            
            if (apidata && apidata.length > 0) {
                if (apidata[0].code !== "-1") {
                    setUserData(apidata);
                    setReferralList(apidata[0].referral || []);
                    setAdminApproval(apidata[0].adminApproval);
                    setIsDocuSigned(apidata[0].isDocuSigned);
                    setReferralLink_RequestStatus(apidata[0].referralLink_RequestStatus);
                    setReferralLink_AdminApproval(apidata[0].referralLink_AdminApproval);
                    setPowerformLink(apidata[0].powerform_url || '');
                    localStorage.setItem('id_sign', window.btoa(apidata[0].userEmail + ':' + apidata[0].fullName));
                } else {
                    logout();
                }
            } else {
                logout();
            }
        } catch (error) {
            console.error('Error fetching dashboard details:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const logout = () => {
        userService.logout();
        setUserData([]);
    };

    // Auth check
    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate to="/signup" replace />;
    }

    // Role check
    try {
        if (window.atob(localStorage.getItem('UserRole')) !== "Distributor") {
            return <Navigate to="/page-not-found" replace />;
        }
    } catch (error) {
        return <Navigate to="/signup" replace />;
    }

    localStorage.setItem('pagename', 'affiliateurl');

    return (
        <div className="w-full">
            {isLoading ? (
                <Card>
                    <CardContent className="flex items-center justify-center p-4 py-12 sm:p-6 sm:py-12">
                        <Loader2 className="h-8 w-8 animate-spin text-accent" />
                    </CardContent>
                </Card>
            ) : userData.length > 0 && userData !== null ? (
                <div className="space-y-6">
                    {/* Page Header */}
                    <h2 className="text-3xl font-bold tracking-tight text-foreground">Affiliate Info</h2>
                    
                    {/* Affiliate URL Section */}
                    <div className="flex flex-col lg:flex-row gap-6 lg:items-stretch">
                        {/* Add Section - Left Sidebar */}
                        <div className="w-full lg:w-64 flex-shrink-0">
                            <Add_sec />
                        </div>
                        
                        {/* URL Card Section - Right Content (stacked vertically) */}
                        <div className="flex-1 flex flex-col gap-6">
                            <Affiliate_id_total Referrals={referralList} />
                            <Pricing_tool profileData={userData} getPricing={getPricing} />
                            <Affiliate_refferal_url 
                                update_affiliate_request={updateAffiliateRequest}
                                powerform_link={powerformLink}
                                isDocuSigned={isDocuSigned}
                                referralLink_AdminApproval={referralLink_AdminApproval}
                                referralLink_RequestStatus={referralLink_RequestStatus}
                            />
                        </div>
                    </div>
                    
                    {/* Referrals List */}
                    <Refferals_list Referrals={referralList} />
                    
                    {/* Active/Inactive Refs */}
                    <Active_inactive_refs />
                </div>
            ) : null}
        </div>
    );
}

export default Affiliate_Url;
